<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/returns/">Returns</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Returns</li>
    </ol>
  </nav>
  <div class="row">
    <div class=" col-xs-12 col-md-4 offset-md-8 col-lg-4 offset-lg-8 col-sm-4 offset-sm-8">
      <input type="text" appOnlyNumbers id="searchOrderNo" [(ngModel)]="searchOrderNumber"
             placeholder="Order Number" [ngModelOptions]="{standalone: true}" class="form-control"
             required (blur)="getReturnOrder()" (keydown.enter)="getReturnOrder()">
      <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!searchError">{{searchError}}</div>
    </div>
  </div>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2>Recipient Information</h2>
          <div class="row mt-3">
            <div class="col-4">
              <label class="mb-1 control-label"><b>Order Number</b> : {{order.orderNumber}}</label><br>
              <label class="mb-1 control-label"><b>Customer</b> : {{order.accountOwnerName}}</label><br>
              <label class="mb-1 control-label"><b>Address</b> : {{order.receiverAddressText}}</label>
            </div>
            <div class="col-4">
              <label class="mb-1 control-label"><b>Sender Name</b> : {{order.senderName}}</label><br>
              <label class="mb-1 control-label"><b>Sender Address</b> : {{order.senderAddressText}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-md-12 mb-1 text-danger fw-500" *ngIf="quantityError || selectReasonError">Please Enter Mandatory
        Fields
      </div>

      <div class="col-12">
        <ul class="list-inline tab-list">
          <li class="list-inline-item ml-2"><a class="list-inline-item" (click)=" tabChange('selectedProducts');"
                                               [ngClass]="{'active': tabClicked === 'selectedProducts'}">Selected
            Products
            <div class="dot bg-danger ml-2" *ngIf="quantityError || selectReasonError"></div>
          </a></li>
          <li class="list-inline-item ml-3"><a class="nav-link warehouses" (click)=" tabChange('shippingOptions');"
                                               [ngClass]="{'active': tabClicked === 'shippingOptions'}">Shipping
            Options</a></li>
        </ul>
        <div class="inner-box inner-box-mobile" style="margin-bottom: 15px!important;">
          <div class="row mt-1" *ngIf="tabClicked == 'selectedProducts'">
            <div class="col-12">
              <!--<h2 class="color-3 text-capitalize mt-3 mb-3">Add Products</h2>-->

              <label style="white-space: nowrap;">Select Reason</label>
              <ng-select [ngClass]="{'service-error':selectReasonError}" (change)="checkError()" (blur)=" typeError()"
                         placeholder="Select Reason" [(ngModel)]="order.returnReason"
                         [ngModelOptions]="{standalone: true}" required [items]="reasonsList" bindLabel="config"
                         bindValue="config">
              </ng-select>
              <div class="ms-3" id="selectReasonError" [hidden] = "!selectReasonError" class="invalid-feedback d-block shift-invalid-login"><strong>{{selectReasonError}}</strong></div>

              <div class="table-3">
                <table class="table  packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th width="35%">SKU</th>
                    <th style="white-space: nowrap!important;" width="35%">Product Name</th>

                    <th width="15%">Quantity</th>
                    <th width="15%">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let ol of orderLines;let i = index">
                    <td class="text-black" width="35%">{{ol.sku}}</td>
                    <td width="35%">{{ol.productName}}</td>

                    <td width="15%">
                      <input style="width:50px;" type="text" id="quantity"
                                                    (keyup)="onKey($event,ol,i)"
                                                    [(ngModel)]="ol.quantity"
                                                    appOnlyNumbers
                                                    [ngModelOptions]="{standalone: true}" class="form-control" required
                                                    [disabled]="ol.previousQuantity==1"
                                                    [ngClass]="{'is-invalid':invalidProductNoEntryError[i]}">
                                             <div id="invalidProductNoEntryError" class="invalid-feedback d-block shift-invalid-login"
                                                  [hidden]="!invalidProductNoEntryError[i]" style="position: absolute;">
                                                  {{invalidProductNoEntryError[i]}}
                                             </div>
                    </td>
                    <td width="15%">

                      <a [hidden]="ol.previousQuantity==1" (click)="removeProduct(ol)">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                          <defs>
                            <style>.a {
                              fill: #848484;
                            }</style>
                          </defs>
                          <path class="a"
                                d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                transform="translate(-7.5 -4.5)"/>
                        </svg>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>

            <div class="col-md-4 mt-3">
              <!--<label style="white-space: nowrap;">Select Reason</label>
              <ng-select [ngClass]="{'service-error':selectReasonError}" (change)="checkError()"
                         placeholder="Select Reason" [(ngModel)]="order.returnReason"
                         [ngModelOptions]="{standalone: true}" required [items]="reasonsList" bindLabel="config"
                         bindValue="config">
              </ng-select>-->
            </div>
          </div>

          <div class="mt-4" *ngIf="tabClicked == 'shippingOptions'">


            <div class="row d-flex justify-content-around">

              <div class="col-md-2 required">
                <div class="form-group">
                  <label class="control-label">Approximate Weight (kg)</label>
                  <input type="text" id="weight" class="form-control" appOnlyNumbers (blur)="typeWeight()" [ngClass]="{'is-invalid':weightError}" [(ngModel)]="weight" [ngModelOptions]="{standalone: true}" placeholder="Weight" required>
                  <div id="weightError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!weightError" style="position: absolute;">{{weightError}}</div>
                </div>
              </div>

              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label">Dimensions (cm)</label>
                  <div class="row">
                    <div class="col-4">
                      <input type="text" id="l" class="form-control"  (blur)="typeLength()" [ngClass]="{'is-invalid':lengthError}" [(ngModel)]="length" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="L" required>
                      <div id="lengthError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!lengthError" style="position: absolute;">{{lengthError}}</div>
                    </div>
                    <div class="col-4">
                      <input type="text" id="w" class="form-control"  (blur)="typeWidth()" [ngClass]="{'is-invalid':widthError}" [(ngModel)]="width" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="W" required>
                      <div id="widthError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!widthError" style="position: absolute;">{{widthError}}</div>
                    </div>
                    <div class="col-4">
                      <input type="text" id="h" class="form-control"  (blur)="typeHeight()" [ngClass]="{'is-invalid':heightError}" [(ngModel)]="height" appOnlyNumbers [ngModelOptions]="{standalone: true}" placeholder="H" required>
                      <div id="heightError"class="invalid-feedback d-block shift-invalid-login" [hidden]="!heightError" style="position: absolute;">{{heightError}}</div>
                    </div>

                  </div>
                </div>
              </div>


              <div class="col-md-4">

                <button type="button" class="btn btn-orange mt-4" (click)="submitCostEstimation()">Fetch Carrier</button>

              </div>
            </div>



            <!--<div class="row">
              <div class="col-md-12  dip-in">
                <div class="form-radio mr-5">
                  <input type="radio" id="shift" [(ngModel)]="order.shippingOption"
                         [ngModelOptions]="{standalone: true}" required value="SHIFT" disabled>
                  <label for="shift">Shift</label>
                </div>
                <br><br>
                &lt;!&ndash;<div class="form-radio">
                  <input type="radio" id="Regular" [(ngModel)]="order.shippingOption"
                         [ngModelOptions]="{standalone: true}" required value="THIRD_PARTY" disabled>
                  <label for="Regular">Third Party Carriers
                    <p class="label-para-size">(Shift will chose the cheapest and fastest carrier)</p>
                  </label>
                </div>&ndash;&gt;
              </div>
            </div>-->
            <!--<div class="row mt-3">
              <div class="col-md-5">
                <h2 class="text-black mb-3">Shipping Instructions</h2>
                  <label  class="mb-1 control-label">{{order.deliveryInstructions|| '&#45;&#45;'}}</label>
              </div>
            </div>-->


            <h2 class="color-3 text-capitalize mt-3 mb-3">Select Your Carrier</h2>
            <div class="mt-3">
              <div class="table-3" style="overflow-x:auto;">
                <table class="table packing-table packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th>Select</th>
                    <th></th>
                    <th>Courier Partner</th>
                    <th>Courier Mode</th>
                    <th>Price</th>
                    <th>Pickup Available</th>
                  </tr>
                  </thead>
                  <tbody >
                  <tr *ngFor="let o of returnPickupCarrierlist;let i=index;">
                    <td>
                      <div class="form-radio">
                        <input type="radio" id="{{i}}" (change)="selectCost(o)" required
                               name="costEstimate">
                        <label for="{{i}}"></label>
                      </div>
                    </td>
                    <td><img src="assets/images/1-{{o.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                    <td>
                      {{(o.carrierCode == 'SD' ? 'Shift' :
                      (o.carrierCode == 'DL' ? 'Delhivery' :
                      (o.carrierCode == 'GT' ? 'Gati' :
                      (o.carrierCode == 'DZ' ? 'Dotzot' :
                      (o.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (o.carrierCode == 'SF' ? 'Shadow Fax' :
                      (o.carrierCode == 'BD' ? 'Blue Dart' :
                      (o.carrierCode == 'PR' ? 'Pickrr' :
                      (o.carrierCode == 'SY' ? 'Ship Yaari' :
                      (o.carrierCode == 'DE' ? 'Delhivery' :
                      (o.carrierCode == 'SG' ? 'Shippigo' :
                      (o.carrierCode == 'VS' ? 'Vamaship' :
                      (o.carrierCode == 'DN' ? 'Dunzo' :
                      (o.carrierCode == 'WF' ? 'Borzo' :
                      (o.carrierCode == 'XB' ? 'Xpressbees' :
                      (o.carrierCode == 'KE' ? 'Kerry' :
                      (o.carrierCode == 'FE' ? 'FedEx' : o.carrierCode)))))))))))))))))}}

                      <div
                           style="display: inline-flex;">{{o.shippingPreference}}
                      </div>
                    </td>
                    <td>
                      <!--<div >
                        {{ (o.serviceType || " ") | replaceStatus}}
                      </div>-->
                      <div >{{o.serviceType | replaceStatus}}</div>
                      <div >{{o.deliveryMode | replaceStatus}}</div>
                      <div>{{o.courier}}</div>
                    </td>
                    <td>{{o.totalAmount | currency:'INR'}}</td>
                    <td>{{"Yes"}}</td>
                  </tr>
                  </tbody>


                  <tfoot>
                  <tr *ngIf="returnPickupCarrierlist?.length ===0 || !returnPickupCarrierlist?.length">
                    <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                  </tr>
                  </tfoot>
                </table>
                <!--<div class="mt-3 m-3" *ngIf="others == true">
                  <div class="row">
                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Carrier Name</label>
                        <input type="text" id="carrierName" class="form-control" [(ngModel)]="carrierName"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="carrierNameBlur()" [ngClass]="{'is-invalid':carrierNameError}">
                        <div [hidden] = "!carrierNameError" class="invalid-feedback d-block shift-invalid-login" id="carrierNameError">
                          {{carrierNameError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label" for="shippedDate">Shipped Date</label>
                        <input type="date" id="shippedDate" class="form-control"packageType
                               [(ngModel)]="shippedDate" [ngModelOptions]="{standalone: true}"
                               (blur)="shippedDateBlur()" [ngClass]="{'is-invalid':shippedDateError}">

                        <div [hidden] = "!shippedDateError" class="invalid-feedback d-block shift-invalid-login" id="shippedDateError">
                          {{shippedDateError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Shipment Cost</label>
                        <input type="text" id="shipmentCost" class="form-control" [(ngModel)]="shipmentCostOther"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="shipmentCostOtherBlur()" [ngClass]="{'is-invalid':shipmentCostOtherError}">
                        <div [hidden] = "!shipmentCostOtherError" class="invalid-feedback d-block shift-invalid-login" id="shipmentCostOtherError">
                          {{shipmentCostOtherError}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label">AWB Number</label>
                        <input type="text" id="AWBNumber" class="form-control" [(ngModel)]="AWBNumber"
                               [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label" for="deliveryPinCode">Tracking URL</label>
                        <input type="text" id="deliveryPinCode" class="form-control"
                               [(ngModel)]="trackingURL" [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>
                  </div>

                </div>-->
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </form>


</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/returns" class="btn btn-cancel">Cancel</button>
      <button type="button" (click)="moveToShipping()" *ngIf="tabClicked != 'shippingOptions'"
              class="btn btn-orange ml-1">Next
      </button>
      <button type="submit" (click)="Submit()" *ngIf="tabClicked == 'shippingOptions'" class="btn btn-orange ml-1"
              [disabled]="!order?.orderNumber">Submit
      </button>
    </div>
  </div>
</div>

